import { useMemo } from "react";
import { SpecialLocation } from "../../models";

// Define the exact order from old system HTML layout
const ORDERED_MAPPING_NAMES = [
  "RAIL_CAR_LOADING_LOCATION_ID",
  "TRUCK_LOADING_LOCATION_ID",
  "COOLING_BED_LOCATION_ID",
  "BACK_PORCH_LOCATION_ID",
  "SCRAP_LOCATION_ID",
  "HOMELESS_LOCATION_ID",
  "BIN_LOCATION_ID",
] as const;

interface UseSpecialLocationsOrderingProps {
  specialLocations: SpecialLocation[];
}

interface UseSpecialLocationsOrderingReturn {
  orderedSpecialLocations: SpecialLocation[];
}

export const useSpecialLocationsOrdering = ({
  specialLocations,
}: UseSpecialLocationsOrderingProps): UseSpecialLocationsOrderingReturn => {
  // Memoize special locations in correct order (matching old system layout)
  const orderedSpecialLocations = useMemo(() => {
    if (specialLocations.length === 0) return [];

    // Create lookup map by MappingName
    const specialLocationMap = new Map<string, SpecialLocation>();
    specialLocations.forEach((location) => {
      if ("MappingName" in location) {
        specialLocationMap.set(location.MappingName, location);
      }
    });

    // Return locations in the correct order, filtering out any that don't exist
    return ORDERED_MAPPING_NAMES.map((mappingName) =>
      specialLocationMap.get(mappingName),
    ).filter((location): location is SpecialLocation => location !== undefined);
  }, [specialLocations]);

  return {
    orderedSpecialLocations,
  };
};
